import { useEffect, useRef, useState } from "react";

const jsonCache: Record<string, any> = {};

export async function fetchJson<T>(url: string, options?: { useCache?: boolean }): Promise<T> {
  if (options?.useCache) {
    if (jsonCache[url]) {
      return Promise.resolve(jsonCache[url] as T);
    } else {
      return fetch(url, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        redirect: "follow",
      })
        .then((res) => res.json() as Promise<T>)
        .then((json) => {
          jsonCache[url] = json;
          return json;
        });
    }
  }
  return fetch(url, {
    method: "GET",
    mode: "cors",
    cache: "no-cache",
    redirect: "follow",
  }).then((res) => res.json() as Promise<T>);
}

export const useFetchJson = <T>(
  url: string,
  options?: { useCache?: boolean },
  onFetch?: (json: T) => void,
): { json: T | undefined; cleanCache: (url: string) => void } => {
  const [result, setResult] = useState<T>(options?.useCache ? jsonCache[url] : undefined);
  const timer = useRef<number | null>();

  useEffect(() => {
    if (options?.useCache && jsonCache[url]) {
      console.log("jsonCache[url] === result", jsonCache[url] === result);
      setResult(jsonCache[url] as T);
    } else {
      console.log("fetch JSON");
      fetchJson<T>(url).then((data) => {
        setResult(data);
        onFetch?.(data);
        if (options?.useCache) {
          jsonCache[url] = data;
        }
      });
    }
  }, [url]);

  useEffect(() => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
    if (options?.useCache) {
      // 1个小时清除一下缓存
      timer.current = setTimeout(() => {
        handleCleanCache();
      }, 60 * 60 * 1000) as unknown as number;
    }

    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    };
  }, [options?.useCache]);

  function handleCleanCache() {
    if (jsonCache[url]) {
      jsonCache[url] = null;
      delete jsonCache[url];
    }
  }

  return { json: result, cleanCache: handleCleanCache };
};
